/** types */
import type { VARIANT_CLASSES } from '~/constants/variant-button-classes'
import type { TFileDownloadInfo } from '~/src/types/download'
import type { TBreadcrumbMenu } from '~/src/types/ui'
import type { DEVICE_SIZES, ENVIRONMENT } from '~/src/constants/common'
import type ButtonDownload from '~/components/shared/common/ButtonDownload.vue'

export type TImageFeature = {
  DEFAULT: string
  SMALL: string
  TINY: string
  MEDIUM: string
  NORMAL: string
  LARGE: string
  EXTRA_LARGE: string
}

export type TImage = {
  src: string
  fetchPriority?: TImageFetchPriority
  classes?: string
  decoding?: TImageDecoding
  loading?: TImageLoading
  alt: string
  width?: string | number
  height?: string | number
}

export type TBannerWithImages = {
  title: string
  images: TRecord[]
  descriptions: TRecord[]
}

export type TImageFetchPriority = 'low' | 'auto' | 'high'

export type TImageLoading = 'lazy' | 'eager'
export type TImageDecoding = 'auto' | 'sync' | 'async'

export type TDevice = (typeof DEVICE_SIZES)[keyof typeof DEVICE_SIZES]

export type TEnvironment = (typeof ENVIRONMENT)[keyof typeof ENVIRONMENT]

export type TCommon =
  | object
  | string
  | unknown
  | undefined
  | null
  | boolean
  | number
  | any

export type TGeneral = {
  [key: string]: TCommon
}

export type TRecord = Record<string, TCommon>

export type TButtonVariants = keyof typeof VARIANT_CLASSES.BASE

export type TTab = {
  name: string
  slug: string
  url: string
  mobileName?: string
}

export type TVideo = {
  coverUrl?: string
  duration: string
  isPublic?: boolean
  previewVimeoId?: string | number
  publishedDate: string
  title: string
  vimeoId?: string | number
}

export type TVideoWithExtra = TVideo & {
  index: number
  slug: string | number
}

export type TMenu = {
  href: string
  name: string
}

/**
 * @deprecated
 * Use `THero` instead, as each component should adapt
 * the image according to its own needs. That will
 * keep the data and presentation layer separate.
 */
export type THeroDeprecated = {
  title: string
  description?: string
  textAlign?: string
  images: THeroImages
  initialFields?: string[]
  file?: TFileDownloadInfo
  breadcrumb?: TBreadcrumbMenu
  downloadText?: string
  showSignIn?: boolean
  hasBookableDemo?: boolean
}

export type THero = Omit<THeroDeprecated, 'images'> & {
  image: string
}

export type THeroImages = {
  desktop: string
  mobile: string
}

export type ButtonDownloadType = InstanceType<typeof ButtonDownload>

export enum ResponseStatus {
  SUCCESS = 'success',
  ERROR = 'error',
  PENDING = 'pending',
  IDLE = 'idle',
}
